import ChangePlanBySimConfirmationDC from "./ChangePlanBySimConfirmationDC";
import PropTypes from "prop-types";

const ChangePlanBySimConfirmationStepper = (props) => {
    const firstStepText =
        `Verrà eseguito il cambio piano sulle seguenti SIM.Il nuovo piano ${props.plan} ha una tariffa mensile di 
    ${props.planCost}.`
    const secondStepText = "La richiesta di cambio piano è stata inoltrata correttamente e sarà effettiva al termine della lavorazione. Potrai seguirne l’andamento dalla sezione Richieste e assistenza.\n" +
        "Chiudi questa finestra per continuare la navigazione"


    const content = {
        0: {
            component: <ChangePlanBySimConfirmationDC
                text={props.firstStepText ? props.firstStepText : firstStepText}
                sims={props.sims}/>
        },
        1: {
            component: <ChangePlanBySimConfirmationDC
                text={props.secondStepText ? props.secondStepText : secondStepText}/>
        }
    }

    return content[props.step].component

};

ChangePlanBySimConfirmationStepper.propTypes = {
    step: PropTypes.number.isRequired,
    sims: PropTypes.arrayOf(
        PropTypes.shape({
            iccId: PropTypes.string.isRequired,
            msisdn: PropTypes.string.isRequired
        }))
};

export default ChangePlanBySimConfirmationStepper;
